import ReactDOM from 'react-dom';
import { useRef } from 'react';
import './ConfirmModal.scss';

function ConfirmMofal({ open, onSetConfirm, onHidePopOver }) {
  const modalRef = useRef();

  if (!open) {
    return null;
  }
  return ReactDOM.createPortal(
    <div className='modal_container'>
      <div ref={modalRef} className='confirm_modal'>
        <div className='modal_title'>
          Are you sure you want to delete this column?
        </div>
        <div className='model_options'>
          <a
            onClick={() => {
              console.log('delete');
            }}
            className='btn'
            href='#'
          >
            Yes
          </a>
          <a
            onClick={() => {
              onSetConfirm(false);
            }}
            className='btn'
            href='#'
          >
            No
          </a>
        </div>
      </div>
    </div>,
    document.getElementById('modal')
  );
}

export default ConfirmMofal;
